<template>
  <div class="container-fluid">
    <loading :active.sync="isLoading" loader="dots"></loading>
    <div class="fixed-list-item">
      <eva-icon fill="#000" name="refresh-outline" @click="reload" />
    </div>
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="">面談日期</label>
              <el-date-picker
                style="width: 100%"
                v-model="search.RangeDate"
                value-format="yyyy-MM-dd"
                type="daterange"
                start-placeholder="開始日期"
                end-placeholder="結束日期"
              >
              </el-date-picker>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">應徵職務</label>
              <el-select
                style="width: 100%"
                v-model="search.ManpowerDemandNo"
                filterable
                clearable
                placeholder="請選擇"
              >
                <el-option
                  v-for="item in positionList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">招募窗口</label>
              <el-select
                style="width: 100%"
                v-model="search.ContactPersonGuid"
                filterable
                clearable
                placeholder="請選擇"
              >
                <el-option
                  v-for="item in contactList"
                  :key="item.Value"
                  :label="item.Text"
                  :value="item.Value"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <div class="form-group">
              <label for="search-name">姓名</label>
              <input
                type="text"
                id="search-name"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.Name"
              />
            </div>
          </div>

          <div class="col-sm-3 col-md-3">
            <button
              type="button"
              @click="getData()"
              class="btn btn-primary"
              style="margin-top: 30px; margin-right: 5px"
            >
              {{ i18n("Buttons.Search") }}
            </button>

            <button
              type="button"
              class="btn btn-secondary"
              style="margin-top: 30px; margin-right: 5px"
              @click="
                search = {
                  RangeDate: search.RangeDate,
                }
              "
            >
              清除
            </button>
          </div>
        </div>
      </div>
    </div>

    <el-tabs v-model="activeName" @tab-click="getData()">
      <el-tab-pane label="英文考試" name="englishTest">
        <div class="yahome-table-wrap">
          <el-table :data="rows" style="width: 100%" height="400px">
            <el-table-column
              prop="InvitationTime"
              label="面試日期"
              sortable
              :formatter="dateFormatter"
            >
            </el-table-column>
            <el-table-column
              prop="Name"
              label="姓名"
              sortable
            ></el-table-column>
            <el-table-column
              prop="ManpowerDemandName"
              label="應徵職務"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="ContactPersonName"
              label="招募窗口"
              sortable
            ></el-table-column>
            <el-table-column prop="EnglishScore" label="英文考試成績" sortable>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane label="邏輯考試" name="logicTest">
        <div class="yahome-table-wrap">
          <el-table :data="rows" style="width: 100%" height="400px">
            <el-table-column
              prop="InvitationTime"
              label="面試日期"
              sortable
              :formatter="dateFormatter"
            >
            </el-table-column>
            <el-table-column
              prop="Name"
              label="姓名"
              sortable
            ></el-table-column>
            <el-table-column
              prop="ManpowerDemandName"
              label="應徵職務"
              sortable
            >
            </el-table-column>
            <el-table-column
              prop="ContactPersonName"
              label="招募窗口"
              sortable
            ></el-table-column>
            <el-table-column prop="LogicScore" label="邏輯考試成績" sortable>
            </el-table-column>
          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 各資訊總覽 -->
    <transition
      name="custom-classes-transition"
      enter-active-class="animated bounceInLeft"
      leave-active-class="animated bounceOutRight"
    >
      <div class="detail-modal" v-if="isShowDetail">
        <div class="detail-modal-inner">
          <div class="menu">
            <a @click.prevent="detailCurrentPage = 0">
              <span>
                <eva-icon name="person-outline" fill="#FFF" />
                履歷
              </span>
            </a>
            <div
              class="close-show-detail"
              @click.prevent="isShowDetail = !isShowDetail"
            >
              <eva-icon
                name="close-circle"
                fill="#FFF"
                width="50"
                height="50"
              />
            </div>
          </div>
          <div class="page-wrap">
            <transition
              name="custom-classes-transition"
              enter-active-class="animated flipInY"
            >
              <perfect-scrollbar v-if="detailCurrentPage === 0" class="page">
                <section class="page-inner">
                  <div class="title">履歷</div>

                  <IdlResume
                    v-if="ResumeType === 'IDL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                  <DlResume
                    v-if="ResumeType === 'DL'"
                    :ResumeId="ResumeId"
                    :ResumeType="ResumeType"
                  />
                </section>
              </perfect-scrollbar>
            </transition>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
/* global $ */
import moment from "moment";
import { mapGetters } from "vuex";
// 履歷(DL/IDL)
import IdlResume from "@/components/customize/Back/IdlResume";
import DlResume from "@/components/customize/Back/DlResume";

export default {
  name: "RoomScheduleSetting",

  components: {
    IdlResume,
    DlResume,
  },
  data() {
    return {
      reloadTime: null, //重新刷新的時間
      startPickerOptions: {
        disabledDate: null,
      },
      endPickerOptions: {
        disabledDate: null,
      },

      detailCurrentPage: 0,
      isShowDetail: false,
      activeName: "englishTest",

      search: {
        RangeDate: [new Date(), new Date()],
      },
      contactList: [],
      positionList: [],
      rows: [],
    };
  },
  watch: {
    "search.InvitationStartTime": function () {
      const startDate = this.search.InvitationStartTime;
      let days = this.dayjs(this.search.InvitationStartTime);

      if (startDate) {
        this.endPickerOptions = {
          disabledDate(date) {
            return date < days;
          },
        };
      }
    },
    "search.InvitationEndTime": function () {
      const endDate = this.search.InvitationEndTime;
      let days = this.dayjs(this.search.InvitationEndTime);

      if (endDate) {
        this.startPickerOptions = {
          disabledDate(date) {
            return date > days;
          },
        };
      }
    },
  },

  methods: {
    reload() {
      //重新讀取
      const today = new Date();
      const hour = today.getHours();
      const min = today.getMinutes();
      const sec = today.getSeconds();

      // 轉成字串，如果低於10，前面加上'0'
      const hourString = hour < 10 ? "0" + hour : "" + hour;
      const minString = min < 10 ? "0" + min : "" + min;
      const secString = sec < 10 ? "0" + sec : "" + sec;

      this.reloadTime = hourString + ":" + minString + ":" + secString;
      this.getData();
    },

    getData() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      let params = {
        ...vm.search,
        ResultType: vm.activeName === "englishTest" ? 1 : 0,

        InvitationStartTime: vm.search.RangeDate
          ? vm.search.RangeDate[0]
          : null,
        InvitationEndTime: vm.search.RangeDate ? vm.search.RangeDate[1] : null,
      };
      vm.$api.InterviewSch.getLogicTestResult(params)
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.rows = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getLogicPosition() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getLogicPosition()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.positionList = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    getLogicTestContact() {
      const vm = this;
      vm.$store.dispatch("updateLoading", true);
      vm.$api.InterviewSch.getLogicTestContact()
        .then((response) => {
          if (response.data.ErrorMessage) {
            this.$notify({
              message: response.data.ErrorMessage,
              type: "error",
            });
          } else {
            vm.contactList = response.data.Data;
          }
          vm.$store.dispatch("updateLoading", false);
        })
        .catch((error) => {
          vm.$store.dispatch("updateLoading", false);
          this.$notify({
            title: "錯誤",
            message: error.response.data.ErrorMessage,
            type: "error",
          });
        });
    },

    dateFormatter(row, column) {
      if (row[column.property]) {
        return this.dayjs(row[column.property]).format("YYYY-MM-DD");
      } else {
        return "";
      }
    },

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    },
  },

  computed: {
    ...mapGetters(["lang"]),
    isLoading() {
      return this.$store.state.isLoading;
    },
  },

  filters: {
    moment: function (date) {
      if (date === null) {
        return null;
      } else {
        return moment(date).format("YYYY-MM-DD HH:mm");
      }
    },
  },

  created() {
    this.getLogicPosition();
    this.getLogicTestContact();
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>

<style lang="scss" scoped>
.name-link {
  background-color: #d9e3ff;
  padding: 3px 15px;
  border-radius: 25px;
  display: inline-block;
  cursor: pointer;
  &.female {
    background-color: #ffd4d4;
  }
}
.p-card {
  background-color: #fff;
  overflow: hidden;
  border-radius: 6px;

  margin: 10px;
  .person-info {
    display: flex;
    padding: 20px;
    position: relative;
    z-index: 2;
    margin-bottom: -20px;
    img {
      width: 100px;
      height: 100px;
      object-fit: cover;
      border-radius: 10px;
      box-shadow: 5px 5px 0 rgba(#000, 0.15);
      margin-right: 15px;
    }
    .info {
      flex: 1;
      .name {
        font-size: 1.5em;
        font-weight: bold;
        margin-bottom: 5px;
      }
      .id {
        font-size: 0.8em;
      }
      .job {
        background-color: #5380f7;
        color: #fff;
        padding: 3px 15px;
        font-size: 0.8em;
        margin-top: 17px;
        border-radius: 25px;
        display: inline-block;
      }
    }
  }
  .job-info {
    background-color: #d9e3ff;
    padding: 20px;
    position: relative;
    &::after {
      content: "";
      width: 200%;
      height: 100px;
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      background-color: #d9e3ff;
      transform: rotate(-7deg);
      transform-origin: top left;
    }
    label {
      background-color: #fff;
      border-radius: 25px;
      padding: 3px 5px;
      overflow: hidden;
      display: flex;
      align-items: center;
      .svg-wrap {
        background-color: #5380f7;
        margin-right: 5px;
        border-radius: 50%;
        padding: 5px;
        width: 30px;
        height: 30px;
        svg {
          width: 100%;
          height: 100%;
          fill: #fff;
          position: relative;
          top: -4px;
        }
      }
      position: relative;
      z-index: 2;
      /deep/ .el-input__inner {
        border: none !important;
      }
      span {
        line-height: 40px;
        margin-left: 10px;
      }
    }
  }
}
</style>
